<ion-header class="ion-padding header header-modal" mode="md">
  <ion-toolbar class="ion-no-padding" mode="ios">
    <ion-title class="ion-text-left ion-no-padding">
      <span *ngIf="mode=='add'">Vpiši podatke za udeleženca</span>
      <span *ngIf="mode!='add'">Uredi podatke za udeleženca</span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onCancel()">
        <ion-icon name="close" mode="md"></ion-icon>
      </ion-button>
      <!--ion-button (click)="userForm.reset()">
        <ion-icon name="close" mode="md"></ion-icon>
      </ion-button-->
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<form [formGroup]="attendeeForm" (ngSubmit)="onSubmit()" (keydown.enter)="handleEnterKey($event)" class="form-wrapper">
  
  <!-- Enable scrolling -->
  <ion-content class="form-content" scroll-y="true">

    <!-- 🔹 GROUP 1: Personal Information -->
    <ion-row>
      <ion-col>
        <h5 class="ion-padding-start"><ion-icon name="person-outline"></ion-icon>&nbsp; Osebni podatki</h5>
      </ion-col>
    </ion-row>

    <ion-item>
      <ion-label position="floating">Ime</ion-label>
      <ion-input formControlName="name" placeholder="Vpiši ime..." type="text"></ion-input>
    </ion-item>
    <div *ngIf="formControls.name.invalid && formControls.name.touched" class="error">
      Ime je obvezen podatek (vsaj 2 znaka).
    </div>

    <ion-item>
      <ion-label position="floating">Priimek</ion-label>
      <ion-input formControlName="surname" placeholder="Vpiši priimek..." type="text"></ion-input>
    </ion-item>
    <div *ngIf="formControls.surname.invalid && formControls.surname.touched" class="error">
      Priimek je obvezen podatek (vsaj 2 znaka).
    </div>


    <!--ion-item button="true" id="open-date-input">
      <ion-icon name="gift-outline"></ion-icon>&nbsp;<ion-label>{{ 'CALENDAR.BOOKING_CUSTOMER_ADD.BIRTHDAY' | translate }}</ion-label>
      <ion-text slot="end">
        {{ attendeeForm.controls.dateOfBirth.value | date:'mediumDate' }}
      </ion-text>
      <ion-popover trigger="open-date-input" show-backdrop="false">
        <ng-template>
          <ion-datetime
            [formControl]="attendeeForm.controls.dateOfBirth"
            presentation="date"
            (ionChange)="onDateChange($event)"
          ></ion-datetime>
        </ng-template>
      </ion-popover>
    </ion-item-->

    <!--ion-item>
      <ion-label position="floating">Telefon</ion-label>
      <ion-input formControlName="phone" placeholder="npr. 031 392 499" type="tel"></ion-input>
    </ion-item>
    <div *ngIf="formControls.phone.invalid && formControls.phone.touched" class="error">
      Vnesi telefonsko številko v pravi obliki!
    </div-->

    <ion-item>
        <ion-label position="floating" mode="md">Telefon</ion-label>
        <ion-intl-tel-input (keydown)="onPhoneKeydown($event)" tabindex="0" ion-intl-tel-input format="national" defaultCountryiso="si"  [preferredCountries]="['si','at', 'de', 'it', 'hr']" formControlName="phone" ></ion-intl-tel-input>
    </ion-item>
    <div *ngIf="formControls.phone.invalid && formControls.phone.touched" class="error">
      Vnesi telefonsko številko v pravi obliki!
    </div>

    <ion-item>
      <ion-label position="floating">E-pošta</ion-label>
      <ion-input #emailInput formControlName="email" placeholder="Vpiši e-pošto..." type="email"></ion-input>
    </ion-item>
    <div *ngIf="formControls.email.invalid && formControls.email.touched" class="error">
      Vnesi veljaven e-poštni naslov!
    </div>


    <!-- 🔹 GROUP 2: Notification Checkbox -->
    <ion-row class="ion-margin-top">
      <ion-col>
        <h5 class="ion-padding-start"><ion-icon name="notifications-outline"></ion-icon>&nbsp; Obveščanje</h5>
      </ion-col>
    </ion-row>

    <ion-item>
      <ion-label>Obveščanje udeleženca?</ion-label>
      <ion-checkbox formControlName="notifications"></ion-checkbox>
    </ion-item>

    <!-- 🔹 GROUP 3: Address Section -->
    <ion-row class="ion-margin-top">
      <ion-col>
        <h5 class="ion-padding-start"><ion-icon name="home-outline"></ion-icon>&nbsp; Naslov</h5>
      </ion-col>
    </ion-row>

    <ion-item>
      <ion-label position="floating">Ulica in hišna številka</ion-label>
      <ion-input formControlName="street" type="text"></ion-input>
    </ion-item>

    <ion-item>
      <ion-label position="floating">Pošta</ion-label>
      <ion-input formControlName="zipCode" type="text"></ion-input>
    </ion-item>
    <div *ngIf="formControls.zipCode.invalid && formControls.zipCode.touched" class="error">
      Vnesi pravilno poštno številko (4-6 znakov).
    </div>

    <ion-item>
      <ion-label position="floating">Kraj</ion-label>
      <ion-input formControlName="city" type="text"></ion-input>
    </ion-item>

    <!--ion-item>
      <ion-label position="floating">Country</ion-label>
      <ion-input formControlName="country" type="text"></ion-input>
    </ion-item-->

    <!-- 🔹 GROUP 4: Identification Section -->
    <!--ion-row class="ion-margin-top">
      <ion-col>
        <h5 class="ion-padding-start"><ion-icon name="id-card-outline"></ion-icon>&nbsp; Identifikacija</h5>
      </ion-col>
    </ion-row-->



    <!--ion-item>
      <ion-label position="floating">EMŠO</ion-label>
      <ion-input formControlName="personalIdentNumber" type="text"></ion-input>
    </ion-item>
    <div *ngIf="formControls.personalIdentNumber.invalid && formControls.personalIdentNumber.touched" class="error">
      EMŠO mora biti dolg natanko 13 znakov.
    </div-->

    <!--ion-item>
      <ion-label position="floating">Številka potnega lista</ion-label>
      <ion-input formControlName="passportNumber" type="text"></ion-input>
    </ion-item-->

  </ion-content>

  <!-- 🔹 Footer with Submit Button -->
  <ion-footer>
    <ion-row class="ion-no-padding">
      <ion-col class="ion-no-padding">
        <ion-button [disabled]="attendeeForm.invalid || (mode === 'edit' && attendeeForm.pristine)" *ngIf="!loading" color="primary" type="submit" (click)="onSubmit()" expand="full" tabindex="12" class="btn--large" #submitBtn> 
          <span *ngIf="mode === 'add'">Dodaj</span><span *ngIf="mode === 'edit'">Spremeni</span>
        </ion-button>
        <ion-button *ngIf="loading" disabled="true" color="secondary" type="button" expand="full" tabindex="12" class="btn--large">
          <ion-spinner name="crescent"></ion-spinner>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-footer>

</form>